import React, { useState, useEffect } from "react";
import { Button, Grid } from "@material-ui/core";
import SystemUpdateIcon from "@material-ui/icons/SystemUpdate";
import styles from "./Home.module.css";
import Search from "../../components/search/Search";
import Subscribe from "../../components/subscribe/Subscribe";
import phone from "../../assets/phone.png";
import AppleIcon from "@material-ui/icons/Apple";
import AndroidIcon from "@material-ui/icons/Android";
import { useStyles } from "./classes";
import { useDispatch } from "react-redux";
import { showSearch, hideSearch } from "../../redux/actions/search";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";
import { useRef } from "react";

const Home = () => {
  gsap.registerPlugin(ScrollTrigger);

  const triggerRight = useRef(null);

  const phoneRef = useRef(null);
  useEffect(() => {
    var triggerRightElem = triggerRight.current;
    var phoneElem = phoneRef.current;
    gsap.fromTo(
      phoneElem,
      {
        opacity: 0,
        y: -300,
      },
      {
        y: 0,
        opacity: 1,
        scrollTrigger: {
          trigger: triggerRightElem,
          scrub: true,
        },
      }
    );
  }, []);

  const rightTxtRef = useRef(null);
  useEffect(() => {
    var triggerRightElem = triggerRight.current;
    var rightTxtRefElem = rightTxtRef.current;
    gsap.fromTo(
      rightTxtRefElem,
      {
        opacity: 0,
        y: 400,
      },
      {
        y: 0,
        duration: 0.5,
        opacity: 1,
        scrollTrigger: {
          trigger: triggerRightElem,
          scrub: true,
        },
      }
    );
  }, []);

  const leftTxtRef = useRef(null);
  useEffect(() => {
    var triggerRightElem = triggerRight.current;
    var leftTxtRefElem = leftTxtRef.current;
    gsap.fromTo(
      leftTxtRefElem,
      {
        opacity: 0,
        y: 300,
      },
      {
        y: 0,
        duration: 0.5,
        opacity: 1,
        scrollTrigger: {
          trigger: triggerRightElem,
          scrub: true,
        },
      }
    );
  }, []);

  const [user, setUser] = useState(JSON.parse(localStorage.getItem("profile"))); // eslint-disable-line
  // const success = useState(JSON.parse(localStorage.Item('SearchSuccess')))
  let dispatch = useDispatch();

  const classes = useStyles();

  useEffect(() => {
    localStorage.removeItem("searchSuccess");
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    dispatch(hideSearch());
    return () => {
      dispatch(showSearch());
    };
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <section className={styles.HeroContainer}>
        {/* <Route render={({ history }) => <Search history={history} />} /> */}
        <Search />
      </section>
      <section className={styles.Introduction}>
        <Button
          className={classes.AppButton}
          startIcon={<SystemUpdateIcon style={{ fontSize: 25 }} />}
        >
          Get the App
        </Button>
      </section>
      <Grid
        container
        justify="center"
        style={{
          margin: 0,
          textAlign: "center",
        }}
      >
        <Grid item xs={12} md={8} sm={8} lg={8} className={styles.Header}>
          <h1 ref={triggerRight} className={classes.headerTitle}>
            What is <span style={{ color: "#D62828" }}>GOTTAMENU?</span>
          </h1>
          <p className={classes.titlePara}>
            GottaMenu is a cloud-hosting platform of restaurant menus where
            people view at their leisure or when traveling.
          </p>
          <p className={classes.titlePara}>
            The platform has several built-in features that makes the experience
            of finding food much more convenient.
          </p>
        </Grid>
      </Grid>
      <section>
        <Grid container className={classes.container}>
          <Grid
            item
            xs={12}
            sm={4}
            md={4}
            lg={4}
            xl={4}
            className={classes.left}
          >
            <Grid ref={leftTxtRef} className={classes.gapOne}>
              <h2 className={classes.subTitle}>Everyday Lifestyle</h2>
              <p className={classes.subPara}>
                GottaMenu makes it easier to view food menus prior to arriving
                at restaurants, whether you are back at home, with friends, or
                traveling in the middle of nowhere.
              </p>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
            <div className={styles.RestaurantOne} />
            <img
              // ref={phoneRef}
              className={styles.PhoneImg}
              src={phone}
              alt="phone"
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={4}
            md={4}
            lg={4}
            xl={4}
            className={classes.right}
          >
            <Grid ref={rightTxtRef} className={classes.gapTwo}>
              <h2 className={classes.subTitle}>Restaurant Businesses</h2>
              <p className={classes.subPara}>
                Bring in more customers to your restaurant by working with us.
                There is a free and easier way to keep your food menu up to
                date, visit the Business tab!
              </p>
              <Grid className={classes.buttonSpace}>
                <Grid className={classes.root}>
                  <Button className={classes.button} startIcon={<AppleIcon />}>
                    App Store
                  </Button>
                  <Button
                    className={classes.button}
                    startIcon={<AndroidIcon />}
                  >
                    Google Play
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            container
            direction="column"
            justify="center"
            alignItems="center"
          >
            <Grid className={classes.rootTwo}>
              <Button className={classes.button} startIcon={<AppleIcon />}>
                App Store
              </Button>
              <Button className={classes.button} startIcon={<AndroidIcon />}>
                Google Play
              </Button>
            </Grid>
            <img className={styles.PhoneImg2} src={phone} alt="phone" />
          </Grid>
        </Grid>
      </section>
      <section>
        <Grid container>
          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <div className={styles.RestaurantTwo} />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={4} xl={4} container>
            <div>
              <Subscribe />
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <div className={styles.RestaurantThree} />
          </Grid>
        </Grid>
      </section>
    </>
  );
};

export default Home;
